// extracted by mini-css-extract-plugin
export default {"main":"HorizontalDivider_main__RTQPQ","small":"HorizontalDivider_small__FViSI","default":"HorizontalDivider_default__u7vbt","tall":"HorizontalDivider_tall__NxzjL"};